$(function(){
  $('.acnav__label').on('click', function () {
    var label = $(this);
    if (label.hasClass('acnav__label--level1')) {
      $(".acnav__label--level1").not(label).each(function(){
        $(this).parent().removeClass('is-open')
               .find('.acnav__list--level2').slideUp('fast');
      });
    }
    var parent = label.parent('.has-children'),
        list   = label.siblings('.acnav__list');
    if (parent.hasClass('is-open')) {
      list.slideUp('fast');
      parent.removeClass('is-open');
    } else {
      list.slideDown('fast');
      parent.addClass('is-open');
    }
  });

  if ($('.mrk-open-above').length) {
    var main  = $('.mrk-open-above').attr('main'),
        child = $('.mrk-open-above').attr('child');
    $(`[mrk-menu-item="${main}"]`).trigger('click');
    $(`[mrk-menu-child-item="${child}"]`).trigger('click');
  }
});

